import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star, Users, Calendar } from 'lucide-react';
import { articleService } from '../services/api';

function FeaturedArticles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await articleService.getAll();
        const featured = response.data
          .filter(article =>
            article.isFeatured &&
            (article.status || '').trim().toLowerCase() === 'published'
          )
          .sort((a, b) => new Date(b.submissionDate) - new Date(a.submissionDate));
        setArticles(featured);
      } catch (error) {
        console.error('Error fetching articles:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">مقالات منتخب</h1>
          <p className="text-xl text-blue-100">بهترین مقالات منتشر شده</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {loading ? (
          <div className="text-center py-12 text-gray-500">در حال بارگذاری...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.id}`}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition overflow-hidden group"
              >
                <div className="bg-gradient-to-r from-blue-700 to-blue-900 text-white p-4 flex items-center justify-between">
                  <h3 className="font-bold flex-1">{article.title}</h3>
                  <Star className="text-yellow-400 flex-shrink-0" size={20} fill="currentColor" />
                </div>
                <div className="p-6">
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3">{article.abstract}</p>
                  <div className="space-y-2 text-sm text-gray-500 pt-4 border-t border-gray-200">
                    <div className="flex items-center gap-2">
                      <Users size={16} className="text-blue-600" />
                      <span>{article.articleAuthors?.length || 0} نویسنده</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Calendar size={16} className="text-blue-600" />
                      <span>{new Date(article.submissionDate).toLocaleDateString('fa-IR')}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FeaturedArticles;
